export const TEST_IDS = {
  createIssueButton: 'create-issue-button',
  templateList: 'template-list',
  issueCreatedLink: 'issue-created-link',
  issueCreatedAnnouncement: 'issue-created-announcement',
}
